export default function (leilao) {
  let window = `leiloes.${leilao.id}.selecaoBens`
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Importação de Lotes',
    width: '90%',
    height: '90%',
    minHeight: '500px',
    backdrop: true,
    clickOutside: false,
    windowClass: 'erp-window-modern',
    contentClass: '__overflow-hidden',
    props: {
      leilao: leilao
    }
  }, () => import('../../bem/components/ListaBens'))
    .then((wid) => {
      this.$uloc.window.listen(wid, {
        loteAdicionado: (wid, val) => {
          this.$emit('loteAdicionado')
        }
      })
    }) // return wid
}
